import React from 'react';
import { bonuses, type Bonus } from '../data/materials';
function BonusBlock({
  bonus,
  reverse
}: {
  bonus: Bonus;
  reverse: boolean;
}) {
  return <div className={`flex flex-col ${reverse ? 'md:flex-row-reverse' : 'md:flex-row'} items-center gap-6 rounded-3xl p-6 bg-[#FDF8EF] border border-[#F0D3AE]`} data-id="element-30" data-mp="1ohyc7r8v92y4">
        <div className="w-full md:w-1/2 flex justify-center" data-id="element-31" data-mp="1yf3324dnpml9">
          <img src={bonus.image} alt={`Bonus Premium: ${bonus.title}`} className="w-[320px] max-w-full h-auto object-contain drop-shadow-xl rounded-lg" data-id="element-32" data-mp="1aogvee7ke4bs" />
        </div>

        <div className="w-full md:w-1/2" data-id="element-33" data-mp="15r740t0m7ilb">
          <span className="inline-block bg-[#F5CE3E] text-[#14356B] text-[10px] font-black tracking-wide px-3 py-1 rounded-full mb-3 uppercase" data-id="element-34" data-mp="1jhanxdc0v07l">
            🎁 Bonus Premium · Gratis
          </span>
          <h3 className="text-xl md:text-2xl font-black mb-2 text-[#14356B] leading-tight" data-id="element-35" data-mp="qzy8y4dy150s">
            {bonus.title}
          </h3>
          <p className="text-base font-bold text-[#157C8B] mb-2" data-id="element-36" data-mp="my3ar8rb77r8">
            {bonus.pages}
          </p>
          <p className="text-lg text-gray-700 mb-3" data-id="element-37" data-mp="29rjtincsmb9a">{bonus.tagline}</p>
          <div className="space-y-2 mb-4" data-id="element-38" data-mp="2eqearkv43rra">
            {bonus.body.map(paragraph => <p key={paragraph} className="text-base text-gray-600" data-id="element-39" data-mp="2ji64g49kedln">
                {paragraph}
              </p>)}
          </div>
          <p className="text-sm font-bold text-gray-500 uppercase tracking-wide mb-2" data-id="element-40" data-mp="2ofxuesqnfpn7">
            {bonus.intro}
          </p>
          <ul className="space-y-1.5 text-base text-gray-800" data-id="element-41" data-mp="1qv1urlzj1b3j">
            {bonus.topics.map(topic => <li key={topic} className="flex items-start" data-id="element-42" data-mp="1vstx79xssflz">
                <span className="text-[#E0872F] mr-2 font-bold" data-id="element-43" data-mp="20qvepqfks6vc">✔</span>
                {topic}
              </li>)}
          </ul>

          {bonus.highlight && <div className="mt-4 bg-white border border-[#B8DCE0] rounded-2xl p-4" data-id="element-44" data-mp="25rsyg7g8h8yy">
              <p className="text-xs font-black text-[#157C8B] tracking-wide mb-1" data-id="element-45" data-mp="3c61yf17r1req">
                {bonus.highlight.label}
              </p>
              <p className="text-base font-black text-[#14356B] mb-1" data-id="element-46" data-mp="1h3f1nn0n754l">
                {bonus.highlight.title}
              </p>
              <p className="text-base text-gray-700" data-id="element-47" data-mp="1c53rtcackumd">{bonus.highlight.text}</p>
            </div>}

          <p className="text-base font-bold text-[#14356B] mt-4" data-id="element-48" data-mp="1q4lhdtvgwbws">
            {bonus.closing}
          </p>
        </div>
      </div>;
}
export function BonusSection() {
  return <section className="py-10 px-4 bg-white" data-id="element-49" data-mp="ycxahmvgkhlc">
      <div className="max-w-5xl mx-auto" data-id="element-50" data-mp="ydyvok66ukgs">
        <div className="text-center mb-8" data-id="element-51" data-mp="yajhdjkc9fgf">
          <h2 className="text-[20px] md:text-2xl font-black text-[#14356B] mb-2" data-id="element-52" data-mp="tem45m4dgp7v">
            🎁 Y ADEMÁS RECIBÍS 2 BONUS PREMIUM
          </h2>
          <p className="text-base font-black text-[#EE6A4D]" data-id="element-53" data-mp="177c1unt9jikt">
            GRATIS CON TU COMPRA
          </p>
        </div>

        <div className="space-y-8" data-id="element-54" data-mp="eowuf2i7rcvz">
          {bonuses.map((bonus, index) => <BonusBlock key={bonus.title} bonus={bonus} reverse={index % 2 === 1} data-id="element-55" data-mp="en3rnyaq1ct9" data-mpi={index} />)}
        </div>
      </div>
    </section>;
}